import {
    APP_DIALOG_SHIFT_DETAILS_OPEN,
    APP_DIALOG_SHIFT_DETAILS_CLOSE,
    APP_DIALOG_ADD_SHIFT_OPEN, APP_DIALOG_ADD_SHIFT_CLOSE
} from "../config/actions";

let defaultState = {
    dialogShiftDetailsOpen: false,
    dialogShiftDetailsShiftId: false,
    dialogAddShiftOpen: false
};

const appReducer = (state = defaultState, action) => {
    switch (action.type) {
        case APP_DIALOG_SHIFT_DETAILS_OPEN:
            return Object.assign({}, state, {
                dialogShiftDetailsOpen: true,
                dialogShiftDetailsShiftId: action.shiftId
            });
        case APP_DIALOG_SHIFT_DETAILS_CLOSE:
            return Object.assign({}, state, {
                dialogShiftDetailsOpen: false,
                dialogShiftDetailsShiftId: false
            });
        case APP_DIALOG_ADD_SHIFT_OPEN:
            return {
                ...state,
                dialogAddShiftOpen: true
            };
        case APP_DIALOG_ADD_SHIFT_CLOSE:
            return {
                ...state,
                dialogAddShiftOpen: false
            };
        default:
            return state;
    }
};

export default appReducer;
